import { gql } from '@apollo/client';

export const SUBMIT_QC_PENALTY_UPLOAD = gql`
  mutation SubmitQcPenaltyUpload(
    $periodStart: String!
    $periodEnd: String!
    $fileBase64: String!
    $fileName: String!
  ) {
    submitQcPenaltyUpload(
      periodStart: $periodStart
      periodEnd: $periodEnd
      fileBase64: $fileBase64
      fileName: $fileName
    )
  }
`;

export const SUBMIT_QC_PENALTY_UPLOAD_RESULT_TO_DOWNLOAD_CENTER = gql`
  mutation SubmitQcPenaltyUploadResultToDownloadCenter($taskId: Long!) {
    submitQcPenaltyUploadResultToDownloadCenter(taskId: $taskId)
  }
`;
